function addTotal(cartTotal) {
  // let newCartTotal = cartTotal.replace(/\D/g, '');
  let newCartTotal = cartTotal.split(">")[1].split("<")[0].replace(/\$/g, "");;
  newCartTotal = parseFloat(newCartTotal);
  console.log(newCartTotal);
  if (localStorage.getItem("realift:hasMeasurements") == "true") {
    if (typeof window.gtag === "function") {
      gtag("event", "realsize_add_total", {
        event_category: "RealSize",
        event_label: "RealSize Add Total",
        value: newCartTotal,
        send_to: "G-PCX3TE6ZTV",
      });
      gtag("event", "realsize_add_transaction", {
        event_category: "RealSize",
        event_label: "RealSize Add Transaction",
        value: 1,
        send_to: "G-PCX3TE6ZTV",
      });
    }
  }
}

window.onload = function () {
  setTimeout(function () {

    const checkout = document.querySelectorAll('[href="/checkout"]');
    // for(let i = 0; i < checkout.length; i++) {
    //   checkout[i].addEventListener("click", function() {
    //     fetch("/cart.js") // Call the fetch function passing the url of the API as a parameter
    //       .then(res => res.json())
    //       .then(function (res) {
    //         addTotal("$" + res.total_price / 100);
    //       })
    //   })
    // }
  }, 1000);
};
